<template>
    <div class="bill-info">
        <div class="btns">
            <a-button type="default" @click="add">添加</a-button>
            <a-button type="default" @click="delBtn">删除</a-button>
        </div>

        <a-table
            :columns="columns"
            :loading="loading"
            :data-source="listData"
            :scroll="{ x: 1200, y: 520 }"
            :pagination="pagination"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        >
            <template slot="action" slot-scope="text, record">
                <a style="display: block" @click="editBill(record)">编辑</a>
                <a style="display: block" @click="deleteBill(record.id)">删除</a>
                <a style="display: block" @click="setDefault(record)">设为默认开票</a>
            </template>

            <div
                slot="defaultInvoice"
                slot-scope="defaultInvoice"
                style="display: flex; align-items: center; justify-content: center"
            >
                <div
                    :style="{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: defaultInvoice == 1 ? '#6DD400' : '#FF3232',
                        marginRight: '4px'
                    }"
                ></div>
                <span>{{ defaultInvoice === '1' ? '是' : '否' }}</span>
            </div>
        </a-table>

        <a-modal :visible="visible" destroyOnClose title="添加新地址" @ok="handleOk" @cancel="handleCancel">
            <custom-form ref="billForm" v-if="visible" :panels="formOption" :fieldsValue="editItemValue"></custom-form>
        </a-modal>
    </div>
</template>

<script>
import { getBillList, delBill, setDefaultBill, addBill, modifyBill } from '../../../common/api';
import customForm from '@/components/custom-form.vue';
import { mapGetters } from 'vuex';

export default {
    components: { customForm },

    data() {
        return {
            visible: false,
            loading: false,
            selectedRowKeys: [],
            listData: [],
            columns: [
                { title: '单位名称', dataIndex: 'createdByOrgName', key: 'createdByOrgName' },
                { title: '纳税人识别号', dataIndex: 'taxpayerIdentificationCode', key: 'taxpayerIdentificationCode' },
                { title: '单位联系人', dataIndex: 'createdByName', key: 'createdByName' },
                { title: '开户银行', dataIndex: 'bank', key: 'bank' },
                { title: '银行账号', dataIndex: 'accountNo', key: 'accountNo' },
                { title: '开票电话', dataIndex: 'taxpayerPhone', key: 'taxpayerPhone' },
                {
                    title: '默认开票',
                    dataIndex: 'defaultInvoice',
                    key: 'defaultInvoice',
                    align: 'center',
                    scopedSlots: { customRender: 'defaultInvoice' }
                },
                {
                    title: '操作',
                    key: 'operation',
                    fixed: 'right',
                    width: 150,
                    scopedSlots: { customRender: 'action' }
                }
            ],
            formOption: [
                {
                    id: 'addBill',
                    gutter: 0,
                    fieldGroup: [
                        [
                            {
                                type: 'select',
                                label: '发票类型、普专',
                                field: 'invoiceCategory',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 },
                                items: [
                                    { label: '普通发票', value: 'normal' },
                                    { label: '专用发票', value: 'special' }
                                ]
                            },
                            {
                                label: '抬头类型',
                                type: 'select',
                                field: 'invoiceTitleCategory',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 },
                                items: [
                                    { label: '个人', value: 'personal1' },
                                    { label: '企业', value: 'company' }
                                ]
                            },
                            {
                                label: '纳税人识别号',
                                field: 'taxpayerIdentificationCode',
                                placeholder: '请输入',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '纳税人电话',
                                field: 'taxpayerPhone',
                                placeholder: '请输入',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '电子邮箱',
                                field: 'email',
                                placeholder: '请输入',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '银行账号',
                                field: 'accountNo',
                                placeholder: '请输入',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '发票抬头',
                                field: 'invoiceTitle',
                                placeholder: '请输入',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '开户行',
                                field: 'bank',
                                placeholder: '请输入',
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            }
                        ]
                    ]
                }
            ],

            editItemValue: {
                invoiceCategory: '',
                invoiceTitleCategory: '',
                taxpayerIdentificationCode: '',
                taxpayerPhone: '',
                email: '',
                accountNo: '',
                bank: '',
                invoiceTitle: ''
            },
            isEdit: false
        };
    },

    computed: {
        ...mapGetters(['userInfo']),

        userId() {
            return this.userInfo.id;
        },

        pagination() {
            return {
                total: this.listData.length,
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal(total) {
                    return `总共${total}条`;
                },

                defaultCurrent: 1
            };
        }
    },

    mounted() {
        this.getList();
    },

    methods: {
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },

        add() {
            this.visible = true;
        },

        delBtn() {
            if (!this.selectedRowKeys.length) {
                return this.$message.warning('请至少选择一条数据');
            }
            const idArr = this.selectedRowKeys.map(t => ({ id: t }));
            this.deleteBill(idArr);
        },

        async handleOk() {
            if (this.isEdit) {
                this.$message.success('修改成功！');
                await modifyBill(this.editItemValue);
            } else {
                const { data } = await addBill(this.userId);
                this.validateForm();
                const params = {
                    id: data,
                    ...this.editItemValue
                };
                await modifyBill(params).then(() => {
                    this.$message.success('新增成功！');
                    this.getList();
                });
            }
            this.$refs['billForm'].form.resetFields();
            this.resetFieldsValue();
        },

        resetFieldsValue() {
            for (const key in this.editItemValue) {
                this.editItemValue[key] = '';
            }
        },

        validateForm() {
            const form = this.$refs['billForm'].form;
            form.validateFields((err, values) => {
                if (!err) {
                    for (const key in values) {
                        if (values[key]) {
                            this.editItemValue[key] = values[key];
                        }
                    }
                }
            });
        },

        handleCancel() {
            this.visible = false;
            this.$refs['billForm'].form.resetFields();
            this.resetFieldsValue();
        },

        async getList() {
            this.loading = true;
            const { data } = await getBillList({ f: { userId_EQ: this.userId }, n: -1 });
            this.listData = data.rows.map(t => {
                return { ...t, key: t.id };
            });
            this.loading = false;
        },

        async deleteBill(params) {
            const isArray = typeof params === 'object';
            const _this = this;
            this.$confirm({
                title: '提示',
                content: isArray ? '确定要删除已勾选的数据吗？' : '确定要删除当前开票信息吗？',
                async onOk() {
                    let idArr = isArray ? params : [{ id: params }];
                    await delBill(idArr);
                    _this.$message.success('删除成功！');
                    _this.getList();
                }
            });
        },

        async editBill(record) {
            for (const key in this.editItemValue) {
                if (record[key]) {
                    this.editItemValue[key] = record[key];
                }
            }
            this.visible = true;
            this.isEdit = true;
        },

        async setDefault(record) {
            if (record.defaultInvoice === '1') {
                return;
            }
            await setDefaultBill(record.id);
            this.$message.success('默认开票修改成功！');
            this.getList();
        }
    }
};
</script>

<style lang="scss" scoped>
.bill-info {
    .btns {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 8px;

        .ant-btn-default {
            background: #ffffff;
            font-size: 14px;
            color: #000000;
            border: 1px solid rgba(217, 217, 217, 1);
            margin-left: 8px;
            font-weight: normal;
            opacity: 0.85;
        }
    }
    .ant-table-wrapper {
        width: 960px;
    }
}
</style>
